<template>
  <div>
    <sp-table-column
      v-for="(item, index) in colList"
      :key="`col_${index}`"
      :width="item.width"
      :color="item.fieldColor">
      <template slot="header">
                <p>{{item.title}}</p>
              </template>
      <template v-slot="{ scope }">
        <div v-if="!item.children" class="span">
          {{scope.row[colList[index].field]}}
        </div>
        <m-table v-if="item.children&&item.children.length>0"
                 :col-list="item.children"
        ></m-table>
      </template>
    </sp-table-column>
  </div>
</template>

<script>
import { spTableColumn } from '@/components/sptable';

export default {
  name: 'mTable',
  components: {
    spTableColumn,
  },
  props: ['colList'],
};
</script>

<style scoped>

</style>
